
export const CREATE_FILE_PERMISSION = 'create_file'
export const CREATE_FOLDER_PERMISSION = 'create_folder'
export const CREATE_FORMS_PERMISSION = 'create_forms'
export const CREATE_FORM_LABELS_PERMISSION = 'create_form_labels'
export const EDIT_FILE_PERMISSION = 'edit_file'

